import { HStack } from '@chakra-ui/react'
import ImageBox from 'components/common/ImageBox'
import IfopNavigation from 'components/markdown/components/IfopNavigation'
import { FC } from 'react'

const IfopConfinementNavigation: FC = () => {
  return (
    <>
      <IfopNavigation
        title="Étude IFOP - Charles"
        links={[
          {
            to: '/ifop-couple-vie-sexuelle-confinement/',
            content: (
              <HStack>
                <ImageBox alt="graph" src="/icons/open-iconic/svg/graph.svg" height="3rem" width="3rem" />
                <span>Ver o relatório</span>
              </HStack>
            )
          },
          {
            to: '/rapport-complet-ifop-vie-sexuelle-affective-confinement/',
            content: (
              <HStack>
                <ImageBox alt="book" src="/icons/open-iconic/svg/book.svg" height="3rem" width="3rem" />
                <span>Voir l&apos;enquête complète</span>
              </HStack>
            )
          }
        ]}
      />
    </>
  )
}

export default IfopConfinementNavigation
